import { useEffect, useState } from 'react'
import { handleError } from '../../lib/utils'
import { message } from 'antd'
import { readMacroTrackerRecipes, saveMacroTrackerRecipe } from '../utils/macro-tracker-utils'
import { useSelector } from 'react-redux'

const useMobileHealthAlternatives = ({ userRef }) => {
  const authState = useSelector((state) => state.auth)
  const [currentRecipe, setCurrentRecipe] = useState(null)
  const [loading, setLoading] = useState(false)
  const [searchQuery, setSearchQuery] = useState('')
  const [saving, setSaving] = useState(false)
  const [cookingMode, setCookingMode] = useState(false)

  const handleSaveRecipe = async (recipe) => {
    setSaving(true)
    try {
      await saveMacroTrackerRecipe({
        ...recipe,
        userRef: authState.agiliteUser._id,
        createdAt: new Date()
      })
      setCurrentRecipe(null)
    } catch (error) {
      message.error(handleError(error))
    }
    setSaving(false)
  }
  return {
    currentRecipe,
    handleSaveRecipe,
    saving,
    setCurrentRecipe,
    searchQuery,
    loading,
    cookingMode,
    setCookingMode,
    setSearchQuery
  }
}

export default useMobileHealthAlternatives
